/*
 * The demo's slim status bar ("Demo · changes aren't saved · Reset") and the sheet shown when
 * something would leave the app. Renders nothing outside demo mode.
 */
import { useEffect, useState } from "react";
import { Chip, Glyph } from "../components/tk";
import { Sheet } from "../components/tk/overlays";
import { DEMO_UNAVAILABLE, isDemo, leaveDemo, resetDemo } from ".";
import "./demo.css";

export function DemoBar() {
  if (!isDemo()) return null;
  return (
    <div className="demo-bar" role="status">
      <span className="demo-bar-text">
        <b>Demo</b>
        <span aria-hidden="true"> · </span>
        changes aren’t saved
      </span>
      <button type="button" className="demo-bar-btn" onClick={resetDemo}>
        Reset
      </button>
      <DemoUnavailableSheet />
    </div>
  );
}

function DemoUnavailableSheet() {
  const [what, setWhat] = useState<string | null>(null);
  useEffect(() => {
    const on = (e: Event) => setWhat((e as CustomEvent<{ what?: string }>).detail?.what ?? "This");
    window.addEventListener(DEMO_UNAVAILABLE, on);
    return () => window.removeEventListener(DEMO_UNAVAILABLE, on);
  }, []);
  return (
    <Sheet
      open={what != null}
      onClose={() => setWhat(null)}
      footer={
        <div className="demo-sheet-actions">
          <Chip tone="primary" onClick={() => setWhat(null)}>
            Got it
          </Chip>
          {import.meta.env.VITE_DEMO !== "1" && (
            <Chip tone="plain" onClick={leaveDemo}>
              Leave the demo
            </Chip>
          )}
        </div>
      }
    >
      <div className="demo-sheet">
        <Glyph icon="lock" color="gray" size={56} round />
        <h2>Not available in the demo</h2>
        <p>{what} needs real money, a wallet or Telegram. Everything else runs on sample data.</p>
      </div>
    </Sheet>
  );
}
